import React from 'react';
import ShowDetails from '../components/ShowDetails';
import { shows } from '../data/shows';

const ShowsListPage: React.FC = () => {
    return (

        <div className="bg-black text-gray-100 min-h-screen">
            <main className="container mx-auto px-4 py-12">


                <div className="grid grid-cols-1 md:grid-cols-5 gap-8" style={{ marginTop: -60 }}>
                    <div className="md:col-span-1">
                    </div>

                    <div className="md:col-span-3">
                        {shows.map((show) => (
                            <ShowDetails key={show.id} show={show} />
                        ))}
                    </div>

                    <div className="md:col-span-1">
                    </div>

                </div>



            </main>
        </div>

    );
};

export default ShowsListPage;